export default {
  adminUrl: (state) => `${state.backendUrl}admin/`,
};
